import { useEffect } from 'react';

import { clientConfig } from '@/config/clientConfig';
import { useApi } from '@/shared/api';
import { useApiMyhub } from '@/shared/apiMyhub/useApiMyhub';

import { useBeneficiariesStore } from '../store/beneficiaries.store';

export const useApiBeneficiaries = () => {
  const api = useApi();
  const apiMyHub = useApiMyhub();
  const { data: beneficiaries, setData: setBeneficiaries, isLoading } = useBeneficiariesStore();

  const fetchBeneficiaries = async () => {
    const { data } = clientConfig.isExported
      ? await apiMyHub.getProfileBeneficiaries()
      : await api.profilesGetBeneficiaries();

    setBeneficiaries(data);
  };

  useEffect(() => {
    fetchBeneficiaries();
  }, []);

  return { beneficiaries, isLoading, fetchBeneficiaries };
};
